// frontend/src/components/citations/CAPEVCitation.jsx

import React from 'react';
import i18n from '../../locales/i18n';
import { resolveCAPEVAdaptation } from '../../activities/cape-v/capevAdaptations';
import CitationLabel from './CitationLabel';

function CAPEVCitation({
    adaptationId = 'en',
    includeAdaptationCitation = true
}) {
    const adaptation = resolveCAPEVAdaptation(adaptationId);
    const citationLanguage = adaptation.id;
    const t = i18n.getFixedT(adaptation.i18nKey);
  
    return (
      <div >
        {['en'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('reprinted_with_permission')}.<br /><br />
          </div>
        )}
    
        {['ca', 'es'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Calaf, N., & Garcia-Quintana, D. (2024). Development and validation of the bilingual Catalan/Spanish cross-cultural adaptation of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Journal of Speech, Language, and Hearing Research, 67</em>(4), 1072–1089. <a href="https://doi.org/10.1044/2024_JSLHR-23-00536" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/2024_JSLHR-23-00536</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2024). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
    
        {['jp'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Kondo, K., Mizuta, M., Kawai, Y., Sogami, T., Fujimura, S., Kojima, T., ... & Haji, T. (2021). Development and validation of the Japanese version of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Journal of Speech, Language, and Hearing Research, 64</em>(12), 4754–4761. <a href="https://doi.org/10.1044/2021_JSLHR-21-00269" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/2021_JSLHR-21-00269</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2021). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
    
        {['fa'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Salary Majd, N., Khoddami, S. M., Drinnan, M., Kamali, M., Amiri-Shavaki, Y., & Fallahian, N. (2014). Validity and rater reliability of Persian version of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Audiology, 23</em>(3), 65–74. © Audiology (2014). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
    
        {['fr'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Pommée, T., Mbagira, D., & Morsomme, D. (2024). French-language adaptation of the Consensus Auditory-Perceptual Evaluation of Voice (CAPE-V). <em>Journal of Voice</em>. <a href="https://doi.org/10.1016/j.jvoice.2024.03.011" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2024.03.011</a>. © <a href="https://www.elsevier.com/" target="_blank" rel="noopener noreferrer">Elsevier</a> (2024). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
    
        {['fr-CA'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Pommée, T., Defoy, L., & Verduyckt, I. (2025). From practice to protocol: The CAPE-VFQ by and for Quebec French SLPs. <em>Clinical Linguistics & Phonetics</em>, 1–12. <a href="https://doi.org/10.1080/02699206.2025.2456214" target="_blank" rel="noopener noreferrer">https://doi.org/10.1080/02699206.2025.2456214</a>. © <a href="https://www.tandfonline.com/" target="_blank" rel="noopener noreferrer">Taylor & Francis</a> (2025). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
    
        {['kn'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Gunjawate, D. R., Ravi, R., & Bhagavan, S. (2020). Reliability and validity of the Kannada version of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Journal of Speech, Language, and Hearing Research, 63</em>(2), 385–392. <a href="https://doi.org/10.1044/2021_JSLHR-21-00269" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/2021_JSLHR-21-00269</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2020). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
    
        {['my'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Mossadeq, N. M., Khairuddin, K. A. M., & Zakaria, M. N. (2022). Cross-cultural adaptation of the Consensus Auditory-Perceptual Evaluation of Voice (CAPE-V) into Malay: A validity study. <em>Journal of Voice</em>. <a href="https://doi.org/10.1016/j.jvoice.2022.05.018" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2022.05.018</a>. © <a href="https://www.elsevier.com/" target="_blank" rel="noopener noreferrer">Elsevier</a> (2022). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
    
        {['pt-br'].includes(citationLanguage) && (
          <div>
            <CitationLabel>
              {t('original_instrument', 'Original instrument')}
            </CitationLabel>
            Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('permission')}.<br /><br />
    
            {includeAdaptationCitation && (
              <>
                <CitationLabel>
                  {t('adaptation', 'Adaptation')}
                </CitationLabel>
                Behlau, M., Rocha, B., Englert, M., & Madazio, G. (2022). Validation of the Brazilian Portuguese CAPE-V Instrument-Br CAPE-V for auditory-perceptual analysis. <em>Journal of Voice, 36</em>(4), 586.e15–586.e20. <a href="https://doi.org/10.1016/j.jvoice.2020.07.007" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2020.07.007</a>. © <a href="https://www.elsevier.com/" target="_blank" rel="noopener noreferrer">Elsevier</a> (2022). {t('reprinted_with_permission')}.<br /><br />
              </>
            )}
          </div>
        )}
      </div>
    );
}

export default CAPEVCitation;
